var _path, _rect, _rect2, _rect3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLeftPlaceholder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.1681 18.9703C36.1681 28.9279 28.0959 37.0001 18.1382 37.0001C8.18064 37.0001 0.108398 28.9279 0.108398 18.9703C0.108398 9.01267 8.18064 0.94043 18.1382 0.94043C28.0959 0.94043 36.1681 9.01267 36.1681 18.9703Z",
    fill: "#D4D3D9"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.3574,
    y: 6.89648,
    width: 15.5573,
    height: 24.4113,
    rx: 1.12687,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.168,
    y: 9,
    width: 12,
    height: 18,
    rx: 0.563433,
    fill: "#D4D3D9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 17.168,
    y: 28,
    width: 1.95238,
    height: 1.94092,
    rx: 0.97046,
    fill: "#D4D3D9"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftPlaceholder);
export default __webpack_public_path__ + "static/media/left_placeholder.a9e9b54209ed5759020949be367ec2aa.svg";
export { ForwardRef as ReactComponent };